module.exports = __webpack_public_path__ + "static/img/20250320007.39f8236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320007.jpg
// module id = W2Ep
// module chunks = 0